// extracted by mini-css-extract-plugin
export var divider = "_o8-0";
export var systemMessage = "_o8-1";